import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ClientAuthProvider, useClientAuth } from '../contexts/ClientAuthContext';
import ClientLoginPage from './ClientLoginPage';
import ClientDashboard from './ClientDashboard';
import MandateSuccessPage from './MandateSuccessPage';

// Protected Route Component for Client
const ClientProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useClientAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Client App Content
const ClientAppContent = () => {
  const { isAuthenticated } = useClientAuth();

  return (
    <Routes>
      <Route path="login" element={
        isAuthenticated ? <Navigate to="/dashboard" replace /> : <ClientLoginPage />
      } />
      <Route path="dashboard" element={
        <ClientProtectedRoute>
          <ClientDashboard />
        </ClientProtectedRoute>
      } />
      <Route path="invoices" element={
        <ClientProtectedRoute>
          <ClientDashboard />
        </ClientProtectedRoute>
      } />
      <Route path="quotes" element={
        <ClientProtectedRoute>
          <ClientDashboard />
        </ClientProtectedRoute>
      } />
      <Route path="documents" element={
        <ClientProtectedRoute>
          <ClientDashboard />
        </ClientProtectedRoute>
      } />
      <Route path="wallet" element={
        <ClientProtectedRoute>
          <ClientDashboard />
        </ClientProtectedRoute>
      } />
      <Route path="settings" element={
        <ClientProtectedRoute>
          <ClientDashboard />
        </ClientProtectedRoute>
      } />
      <Route path="mandate-success" element={
        <ClientProtectedRoute>
          <MandateSuccessPage />
        </ClientProtectedRoute>
      } />
      <Route path="" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

// Main Client App with Auth Provider
const ClientApp = () => {
  return (
    <ClientAuthProvider>
      <ClientAppContent />
    </ClientAuthProvider>
  );
};

export default ClientApp;